import System from 'system'

export const ACCESS_LEVELS = {
  ADMIN: 0b00000001,
  EDITOR: 0b00000010,
  REPORTER: 0b00000100,
}

export enum BOTS {
  'events' = 'events-bot@sweatbits.co',
  'fixtures' = 'fixtures-bot@sweatbits.co',
  'info' = 'info@sweatbits.co',
  'plain' = 'plain-bot@sweatbits.co',
  'scraper' = 'scraper-bot@sweatbits.co',
  'tournaments' = 'tournaments-bot@sweatbits.co',
}

export enum BOTS_SOCCER_CUP {
  'sc_support' = 'soporte@torneosoccercup.com',
}

export const isAdmin = (accessLevel = 0) => (accessLevel & ACCESS_LEVELS.ADMIN) === ACCESS_LEVELS.ADMIN

export const isEditor = (accessLevel = 0) => (accessLevel & ACCESS_LEVELS.EDITOR) === ACCESS_LEVELS.EDITOR

export const isReporter = (accessLevel = 0) => (accessLevel & ACCESS_LEVELS.REPORTER) === ACCESS_LEVELS.REPORTER

export const isBot = (email: string): boolean => Object.values(BOTS).includes(email as BOTS)

export const isBotSoccerCup = (email: string): boolean =>
  Object.values(BOTS_SOCCER_CUP).includes(email as BOTS_SOCCER_CUP)

export const navigateToMatch = (id: string, newWindow = false) => {
  try {
    if (newWindow) {
      window.open(`${System.url}/sports/soccer/match/${id}`, 'sweatbits')
    } else {
      System.history.push(`/sports/soccer/match/${id}`)
    }
  } catch (e) {
    if (newWindow) {
      window.open(`${System.url}/sports/soccer/match/${id}`, 'sweatbits')
    } else {
      System.history.push(`/sports/soccer/match/${id}`)
    }
  }
}

export const robotImage = (style: 'avatar' | 'picture', id: string, gender: 'F' | 'f' | 'M' | 'm' = 'm') => {
  const filenamesM = [
    'alexis',
    'alves',
    'arda',
    'benzema',
    'bravo',
    'david',
    'dempsey',
    'falcao',
    'griezzman',
    'howard',
    'kane',
    'lampard',
    'leward',
    'luka',
    'marcelo',
    'modric',
    'neymar',
    'oscar',
    'pogba',
    'rakitic',
    'ronaldo',
    'rooney',
    'thiago',
    'tosun',
    'varane',
    'vidal',
  ]
  const filenamesF = ['caryl', 'lady', 'louisa', 'marta', 'morgan', 'rachel', 'thiney']
  const genderUser = gender === 'm' || gender === 'M' ? 'm' : 'f'
  const list = genderUser === 'm' ? filenamesM : filenamesF
  const pos = +id.replaceAll(/(\D+)/g, '') % list.length
  const player = list[pos]
  const image = `${genderUser}_${style === 'avatar' ? 'avatar_' : 'banner_'}${player}.jpg`
  return `https://static.sweatbits.co/content/sweatbits/players/${image}`
}

export const isRootUser = (email: string) => email === 'info@sweatbits.co'

export const print = () => {
  // @ts-expect-error printBase is not defined in the window object
  const printFunction = window?.printBase || window?.print
  if (printFunction) {
    if (System.device.model) {
      System.addNotification({
        id: 'print-error',
        children: (
          <div>
            Por favor utiliza la última versión de Chrome o Safari para guardar o imprimir mientras solucionamos el
            inconveniente.
          </div>
        ),
        dismissAfter: 20000,
        icon: 'print',
        status: 'WARNING',
        title: `La impresión puede fallar en ${System.device.model}`,
      })
    }
    window.scrollTo({
      behavior: 'instant',
      left: 0,
      top: 0,
    })
    try {
      printFunction()
      return
    } catch (error: unknown) {
      if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.error('Error printing:', error)
      }
    }
  }
  System.addNotification({
    id: 'print-error',
    children: <div>Por favor utiliza la última versión de Chrome o Safari para guardar o imprimir.</div>,
    dismissAfter: 20000,
    icon: 'print',
    status: 'ERROR',
    title: 'No es posible la impresión',
  })
}

export const isSoccerCup = ({ id }: { id: string }) => id === '11ea1b92e0dee600932997dab6868a51'
